import React, { useState, useEffect } from 'react';
import './SplashScreen.css';
import MessageSVG from './Message';

const SplashScreen = () => {

    const [isBeating, setBeating] =
        useState(false);

    useEffect(() => {

        const intervalId = setInterval(() => {

            setBeating(prevState => !prevState);
        }, 700);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: '#111111'
        }}>
            <div className={`heartbeat ${isBeating ? 'beat' : ''}`}>
                <MessageSVG color={'#128ff9'} height={300} width={300} />
            </div>
        </div>
    );
};

export default SplashScreen;
